import request from '@/utils/request'

export function addTemplate(query) {
  return request({
    url: '/template',
    method: 'post',
    data: query
  })
}

export function searchTemplate(query) {
  return request({
    url: '/template/search',
    method: 'post',
    data: query
  })
}
export function getTemplateByid(id) {
  return request({
    url: '/template/' + id,
    method: 'get'

  })
}
export function editTemplate(query) {
  return request({
    url: '/template/edit/' + query.id,
    method: 'post',
    data: query
  })
}

// 查询会议室
export function searchRoom(data) {
  data.room_status = 1
  return request({
    url: '/room/search',
    method: 'post',
    data: data
  })
}
// 查询会议室
export function createMeeting(data) {
  return request({
    url: '/template/createMeeting',
    method: 'post',
    data: data
  })
}
// 删除会议室
export function deleteTemplate(id) {
  return request({
    url: 'template/delete/' + id,
    method: 'get'

  })
}
